import React from 'react';

import styles from './compensationCardStyles';

import CardGrayBanner from 'buyside/components/presentation/CardGrayBanner/cardGrayBanner';
import CompensationCardTop from './CompensationCards/compensationCardTop';
import CompensationCardBottom from './CompensationCards/compensationCardBottom';

import { formatDate } from 'buyside/util/dateHelper';
import { formatCompensations } from 'buyside/util/formatNumber';

const CompensationCard = ({ node, isAdmin }) => {
  const {
    baseSalary,
    interestIncentiveFeesValue,
    interestMgmtFeesValue,
    annualDiscrBonus,
    totalCashComp,
    postedAt
  } = node;
  const date = formatDate(postedAt);
  const annualCarriedInterest = interestIncentiveFeesValue + interestMgmtFeesValue;
  const bannerDisplayItems = [
    { title: 'Base Salary', value: formatCompensations(baseSalary) },
    { title: 'Annual Carried Interest', value: formatCompensations(annualCarriedInterest) },
    { title: 'Other Cash Bonus', value: formatCompensations(annualDiscrBonus) },
    { title: 'Total Cash Compensation', value: formatCompensations(totalCashComp) },
    { title: 'Posted', value: date }
  ];

  return (
    <div className={styles.cardContainer}>
      <CompensationCardTop node={node} />
      <CardGrayBanner displayItems={bannerDisplayItems} />
      <CompensationCardBottom node={node} isAdmin={isAdmin} />
    </div>
  );
};

export default CompensationCard;
